//File to add role based logic
import { ROLES } from "./constants";

export const isRoleDirector = (role: string | undefined) => {
    if (!role) return false;
    return [
        ROLES.reception_director,
        ROLES.neurofeedback_director,
        ROLES.technical_director,
        ROLES.human_resources_manager,
    ].includes(role);
};

export const isRoleAdmin = (role: string | undefined) => {
    if (!role) return false;
    return [
        ROLES.admin,
        ROLES.shilan,
        ROLES.tech_admin,
    ].includes(role);
};

export const isRoleBackOffice = (role: string | undefined) => {
    if (!role) return false;
    return [
        ROLES.back_office,
    ].includes(role);
};

export const isRoleTechnicianSupervisor = (role: string | undefined) => {
    if (!role) return false
    return [
        ROLES.neurofeedback_director,
        ROLES.technical_director,
    ].includes(role);

}

export const isRoleTechnician = (role: string | undefined) => {
    if (!role) return false
    return [
        ROLES.nfb_techncians,
        ROLES.client_owner,
        ROLES.nfb_and_theurapist,
        ROLES.theurapist,
    ].includes(role);
}

export const isNfbRelatedRole = (role: string | undefined) => {
    if (!role) return false;
    return [
        ROLES.client_owner,
        ROLES.nfb_techncians,
        ROLES.nfb_and_theurapist,
    ].includes(role);
};

export const isRoleMarketingManager = (role: string | undefined) => {
    if (!role) return false
    return [
        ROLES.marketing_manager,
    ].includes(role);
}